export default __webpack_public_path__ + "static/media/Repaired.b2518d45.svg";